module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/61.082d4161.png";